/* eslint-disable import/no-mutable-exports, global-require, no-console */
var amplitude;
if (process.env.SERVER) {
  /* istanbul ignore */
  amplitude = {
    getInstance: function getInstance() {
      return {};
    },
    mock: true
  };
} else {
  try {
    amplitude = require('amplitude-js');
  } catch (err) {
    console.log('Tried to import amplitude-js, but it\'s not installed \n', err);
    amplitude = {
      getInstance: function getInstance() {
        return {};
      },
      mock: true
    };
  }
}
export default amplitude;